import * as ActionCable from '@rails/actioncable';

window.App = window.App || {};
window.App.cable = ActionCable.createConsumer();

// Import channels
import './channels/signature_channel';
import './channels/subscription_intentions_selection_channel';
import './channels/user_membership_channel';
import './channels/waiting_list_channel';
